<template>
  <fragment>
    <portal to="screen-actions">
      <a
        class="btn btn-primary mt-2 mt-xl-0"
        @click="openAddDrawer"
      >
        <i class="far fa-plus"></i> Camera
      </a>
    </portal>
    <div class="container container-fluid mt-4 mb-4">
      <div class="card card-report">
        <div class="row gx-0">
          <div class="col-md-4 col-xl-3 col-select">
            <nav class="navbar navbar-expand-md navbar-light">
              <div class="container-fluid d-block">

                <div class="nav-heading">
                  <div class="row">
                    <div class="col d-flex align-items-center">
                      <h2>Select Camera</h2>
                    </div>
                  </div><!-- /.row -->
                </div>

                <div class="collapse navbar-collapse" id="navbarReportSelect" v-if="cameras.length">
                  <ul class="nav navbar-nav flex-column" role="tablist">
                    <li class="nav-item" role="presentation" v-for="camera in cameras" :key="camera.id">
                      <router-link
                        class="nav-link"
                        id="tab-screen-status"
                        type="button"
                        role="tab"
                        aria-controls="screen-status"
                        aria-selected="true"
                        :to="{ name: 'screens.single.camera-settings.camera', params: {'cameraId': camera.id} }"
                        exact
                      >
                        {{ camera.name }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </nav><!-- /.navbar -->

          </div>
          <div class="col col-configure tab-content tab-content-reports">
            <div
              class="tab-pane fade show active"
              role="tabpanel"
              aria-labelledby="tab-screen-status"
            >
              <router-view/>
            </div>
          </div>
        </div><!-- /.row -->
      </div><!-- /.card -->
    </div><!-- /.container -->
    <add-camera-drawer ref="addCameraDrawer" />
  </fragment>
</template>

<script>
import { helperComputed, helperMethods } from '@/vuex/modules/screens/cameras'
import AddCameraDrawer from '@/views/screens/camera-settings/AddCameraDrawer.vue'

export default {
  components: {
    AddCameraDrawer
  },

  beforeDestroy () {
    this.resetCameras()
  },

  async created () {
    await this.getCameras()
  },

  computed: {
    ...helperComputed,
  },

  methods: {
    ...helperMethods,

    openAddDrawer () {
      this.$refs.addCameraDrawer.open()
    }
  }
}
</script>
